import Router from "@router/Router";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")).render(<Router />);
